/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ForceInputs */

const en_entity_force = /** @type {(inputs: Entity_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

const de_entity_force = /** @type {(inputs: Entity_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwingen`)
};

/**
* | output |
* | --- |
* | "Force" |
*
* @param {Entity_ForceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_force = /** @type {((inputs?: Entity_ForceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ForceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_force(inputs)
	return de_entity_force(inputs)
});